const actions = {
  GET_SINGLE_PRODUCT_BEGIN: 'GET_SINGLE_PRODUCT_BEGIN',
  GET_SINGLE_PRODUCT_SUCCESS: 'GET_SINGLE_PRODUCT_SUCCESS',
  GET_SINGLE_PRODUCT_ERR: 'GET_SINGLE_PRODUCT_ERR',
  GET_SINGLE_PRODUCT_RESET: 'GET_SINGLE_PRODUCT_RESET',

  ADD_PRODUCT_BEGIN: 'ADD_PRODUCT_BEGIN',
  ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
  ADD_PRODUCT_ERR: 'ADD_PRODUCT_ERR',

  EDIT_PRODUCT_BEGIN: 'EDIT_PRODUCT_BEGIN',
  EDIT_PRODUCT_SUCCESS: 'EDIT_PRODUCT_SUCCESS',
  EDIT_PRODUCT_ERR: 'EDIT_PRODUCT_ERR',
  EDIT_PRODUCT_RESET: 'EDIT_PRODUCT_RESET',

  GET_ALL_PRODUCTS_BEGIN: 'GET_ALL_PRODUCTS_BEGIN',
  GET_ALL_PRODUCTS_SUCCESS: 'GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_ERR: 'GET_ALL_PRODUCTS_ERR',

  SINGLE_PRODUCT_BEGIN: 'SINGLE_PRODUCT_BEGIN',
  SINGLE_PRODUCT_SUCCESS: 'SINGLE_PRODUCT_SUCCESS',
  SINGLE_PRODUCT_ERR: 'SINGLE_PRODUCT_ERR',

  FILTER_PRODUCT_BEGIN: 'FILTER_PRODUCT_BEGIN',
  FILTER_PRODUCT_SUCCESS: 'FILTER_PRODUCT_SUCCESS',
  FILTER_PRODUCT_ERR: 'FILTER_PRODUCT_ERR',

  SORTING_PRODUCT_BEGIN: 'SORTING_PRODUCT_BEGIN',
  SORTING_PRODUCT_SUCCESS: 'SORTING_PRODUCT_SUCCESS',
  SORTING_PRODUCT_ERR: 'SORTING_PRODUCT_ERR',

  getAllProductsBegin: () => {
    return {
      type: actions.GET_ALL_PRODUCTS_BEGIN,
    };
  },

  getAllProductsSuccess: (data) => {
    return {
      type: actions.GET_ALL_PRODUCTS_SUCCESS,
      data,
    };
  },

  getAllProductsErr: (err) => {
    return {
      type: actions.GET_ALL_PRODUCTS_ERR,
      err,
    };
  },

  getSingleProductReset: () => {
    return {
      type: actions.GET_SINGLE_PRODUCT_RESET,
    };
  },

  getSingleProductBegin: () => {
    return {
      type: actions.GET_SINGLE_PRODUCT_BEGIN,
    };
  },

  getSingleProductSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_PRODUCT_SUCCESS,
      data,
    };
  },

  getSingleProductErr: (err) => {
    return {
      type: actions.GET_SINGLE_PRODUCT_ERR,
      err,
    };
  },

  addProductBegin: () => {
    return {
      type: actions.ADD_PRODUCT_BEGIN,
    };
  },

  addProductSuccess: (data) => {
    return {
      type: actions.ADD_PRODUCT_SUCCESS,
      data,
    };
  },

  addProductErr: (err) => {
    return {
      type: actions.ADD_PRODUCT_ERR,
      err,
    };
  },

  editProductBegin: () => {
    return {
      type: actions.EDIT_PRODUCT_BEGIN,
    };
  },

  editProductSuccess: (data) => {
    return {
      type: actions.EDIT_PRODUCT_SUCCESS,
      data,
    };
  },

  editProductReset: () => {
    return {
      type: actions.EDIT_PRODUCT_RESET,
    };
  },

  editProductErr: (err) => {
    return {
      type: actions.EDIT_PRODUCT_ERR,
      err,
    };
  },

  singleProductBegin: () => {
    return {
      type: actions.SINGLE_PRODUCT_BEGIN,
    };
  },

  singleProductSuccess: (data) => {
    return {
      type: actions.SINGLE_PRODUCT_SUCCESS,
      data,
    };
  },

  singleProductErr: (err) => {
    return {
      type: actions.SINGLE_PRODUCT_ERR,
      err,
    };
  },

  filterProductBegin: () => {
    return {
      type: actions.FILTER_PRODUCT_BEGIN,
    };
  },

  filterProductSuccess: (data) => {
    return {
      type: actions.FILTER_PRODUCT_SUCCESS,
      data,
    };
  },

  filterProductErr: (err) => {
    return {
      type: actions.FILTER_PRODUCT_ERR,
      err,
    };
  },

  sortingProductBegin: () => {
    return {
      type: actions.SORTING_PRODUCT_BEGIN,
    };
  },

  sortingProductSuccess: (data) => {
    return {
      type: actions.SORTING_PRODUCT_SUCCESS,
      data,
    };
  },

  sortingProductErr: (err) => {
    return {
      type: actions.SORTING_PRODUCT_ERR,
      err,
    };
  },
};

export default actions;
